import { render, staticRenderFns } from "./ParamTipoImposto.vue?vue&type=template&id=7e167c14"
import script from "./ParamTipoImposto.vue?vue&type=script&lang=js"
export * from "./ParamTipoImposto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports